import styled from 'styled-components'

import neilPhoto from '../../styles/assets/megaMenu/neilPhoto.png'
import { fonts, palette } from '../../styles/variables'
import { getLanguageCode, translate } from '../../utils/translation'
import { MIXPANEL_PROPS, Mixpanel } from '../../utils/mixpanel'

const Container = styled.div({
  backgroundColor: palette.orange10,
  padding: 32,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: '262px',
  minWidth: '262px',
  marginTop: 8,
  alignSelf: 'flex-start',
  gap: 29,
})

const Title = styled.h4({
  fontSize: '20px',
  lineHeight: '26px',
  fontFamily: fonts.primaryBook,
  marginBottom: 8,
  marginTop: 16,
  b: {
    color: palette.orange,
    fontFamily: fonts.primaryBook,
  },
})

const CTAButton = styled.button({
  fontFamily: fonts.primaryMedium,
  color: palette.white,
  padding: 8,
  textTransform: 'uppercase',
  lineHeight: '24px',
  fontSize: getLanguageCode() === 'it' ? '12px' : '14px',
  letterSpacing: '0.08em',
  height: '40px',
  minWidth: '100%',
  backgroundColor: palette.blue,
  outline: 'none',
  border: 'none',
  borderRadius: '2px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

const Paragraph = styled.p({
  fontSize: '12px',
  lineHeight: '19.2px',
})

const NeilCard = ({
  title,
  description,
  href,
  mixPanelMenuSubItemName,
  mixPanelButtonLocation,
}) => (
  <Container>
    <div>
      <img src={neilPhoto} alt="Neil Patel" width={56} height={56} />
      <Title dangerouslySetInnerHTML={{ __html: translate(title) }} />
      <Paragraph dangerouslySetInnerHTML={{ __html: translate(description) }} />
    </div>

    <CTAButton
      data-href={href}
      onClick={() => {
        Mixpanel.trackNPDConsultingClick({
          [MIXPANEL_PROPS.MENU_SUBITEM_NAME.name]: mixPanelMenuSubItemName,
          [MIXPANEL_PROPS.BUTTON_LOCATION.name]: mixPanelButtonLocation,
        })

        window.open(href, '_blank')
      }}
    >
      {translate('book_a_call')}
    </CTAButton>
  </Container>
)

export default NeilCard
